'use strict';

var React = require('react');

var SvgFileFilledMinor = function SvgFileFilledMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9 3h-2.75a1.75 1.75 0 0 0-1.75 1.75v10.5c0 .966.784 1.75 1.75 1.75h7.5a1.75 1.75 0 0 0 1.75-1.75v-5.795h-4.87a1.625 1.625 0 0 1-1.626-1.624l-.003-4.831Zm-1.975 11c0-.483.392-.875.875-.875h4.2a.875.875 0 0 1 0 1.75h-4.2a.875.875 0 0 1-.875-.875Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.35 8.205h-4.72a.375.375 0 0 1-.376-.375l-.003-4.699c.212.087.407.216.572.382l4.164 4.164c.154.154.276.333.363.528Z"
  }));
};
SvgFileFilledMinor.displayName = "FileFilledMinor";

exports.SvgFileFilledMinor = SvgFileFilledMinor;
